import React from "react";
import PropTypes from "prop-types";

const Conditional = ({ if: condition, children }) =>
  condition ? <>{children}</> : null;

Conditional.propTypes = {
  if: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
};

export default Conditional;
